import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <span className="text-xl font-bold">oneclickAIseo</span>
            </div>
            <p className="text-gray-300 mb-4 text-lg">
              The most advanced AI-powered SEO analysis tool for websites. Get instant SEO insights, 
              keyword analysis, and optimization recommendations. Perfect for AI and SEO professionals.
            </p>
            <div className="flex space-x-4">
              <a href="https://twitter.com/oneclickaiseo" className="text-gray-400 hover:text-white transition-colors" aria-label="Follow us on Twitter">
                <span className="sr-only">Twitter</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a href="https://linkedin.com/company/oneclickaiseo" className="text-gray-400 hover:text-white transition-colors" aria-label="Connect with us on LinkedIn">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.299v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.299C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="https://facebook.com/oneclickaiseo" className="text-gray-400 hover:text-white transition-colors" aria-label="Like us on Facebook">
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M20 10C20 4.477 15.523 0 10 0S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

          {/* AI SEO Tools */}
          <div>
            <h4 className="text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
              AI SEO Tools
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Free SEO Analysis
                </Link>
              </li>
              <li>
                <Link to="/analysis" className="text-gray-300 hover:text-white transition-colors">
                  SEO Reports
                </Link>
              </li>
              <li>
                <Link to="/history" className="text-gray-300 hover:text-white transition-colors">
                  Analysis History
                </Link>
              </li>
              <li>
                <a href="/keyword-research" className="text-gray-300 hover:text-white transition-colors">
                  Keyword Research
                </a>
              </li>
              <li>
                <a href="/competitor-analysis" className="text-gray-300 hover:text-white transition-colors">
                  Competitor Analysis
                </a>
              </li>
            </ul>
          </div>

          {/* SEO Resources */}
          <div>
            <h4 className="text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
              SEO Resources
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/seo-guide" className="text-gray-300 hover:text-white transition-colors">
                  SEO Guide
                </a>
              </li>
              <li>
                <a href="/ai-seo-blog" className="text-gray-300 hover:text-white transition-colors">
                  AI SEO Blog
                </a>
              </li>
              <li>
                <a href="/seo-tools" className="text-gray-300 hover:text-white transition-colors">
                  SEO Tools
                </a>
              </li>
              <li>
                <a href="/case-studies" className="text-gray-300 hover:text-white transition-colors">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="/seo-news" className="text-gray-300 hover:text-white transition-colors">
                  SEO News
                </a>
              </li>
            </ul>
          </div>

          {/* Support & Company */}
          <div>
            <h4 className="text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
              Support & Company
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/help-center" className="text-gray-300 hover:text-white transition-colors">
                  Help Center
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/api-docs" className="text-gray-300 hover:text-white transition-colors">
                  API Documentation
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="/careers" className="text-gray-300 hover:text-white transition-colors">
                  Careers
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* SEO Keywords Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="text-center">
            <h4 className="text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
              Popular SEO & AI Keywords
            </h4>
            <div className="flex flex-wrap justify-center gap-2">
              {[
                'AI SEO', 'SEO analysis', 'website optimization', 'search engine optimization',
                'AI tools', 'SEO checker', 'free SEO tool', 'website analysis', 'SEO audit',
                'AI-powered SEO', 'digital marketing', 'web optimization', 'search engine marketing',
                'SEO consultant', 'website SEO', 'online SEO tool', 'AI marketing tools'
              ].map((keyword, index) => (
                <a
                  key={index}
                  href={`/seo-keywords/${keyword.toLowerCase().replace(/\s+/g, '-')}`}
                  className="px-3 py-1 bg-gray-800 text-gray-300 text-sm rounded-full hover:bg-blue-600 hover:text-white transition-colors"
                >
                  {keyword}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>© {currentYear} oneclickAIseo.com. All rights reserved.</p>
              <p className="mt-1">AI-Powered SEO Analysis Tool for Better Search Rankings</p>
            </div>
            <div className="flex space-x-6">
              <a href="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <a href="/sitemap" className="text-gray-400 hover:text-white text-sm transition-colors">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
